import { render } from "./App.vue?vue&type=template&id=81d5c9ec"
const script = {}

import "./App.vue?vue&type=style&index=0&id=81d5c9ec&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__